import { MARKET, ACCOUNT, MARKETPLACE_LISTING_PATHS } from "./marketplaceRoutes";

const MARKETPLACE_EXACT = new Set([
  MARKET.HOME,
  MARKET.SELL,
  MARKET.CART,
  MARKET.CART_EMPTY,
  MARKET.CHECKOUT,
  MARKET.SEARCH,
  MARKET.RETURN_POLICY,
  MARKET.TRACK_ORDER,
  MARKET.PAYMENT_VERIFICATION,
  ACCOUNT.HOME,
  ACCOUNT.ORDERS,
  ACCOUNT.SAVED,
  ACCOUNT.INBOX,
  ACCOUNT.SETTINGS,
  ACCOUNT.RECENT,
  ACCOUNT.REVIEWS,
  ACCOUNT.ADDRESSES,
  ...MARKETPLACE_LISTING_PATHS,
]);

const MARKETPLACE_PREFIXES = [
  "/market/product/",
  "/market/order-confirmation/",
  "/account/orders/",
];

export const isMarketplaceRoute = (pathname = "") => {
  if (!pathname) return false;
  if (MARKETPLACE_EXACT.has(pathname)) return true;
  return MARKETPLACE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export default isMarketplaceRoute;
